import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden" data-id="element-90">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-91" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-93">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-8" data-id="element-94">
            💪 SÌ! VOGLIO IL SISTEMA INTEGRATO ITALIANO™ ORA
          </h2>

          <CTAButton href="https://italia.kitonline.shop/cart/44566018293895:1" className="text-xl sm:text-2xl py-6 px-10 w-full sm:w-auto max-w-xl mx-auto mb-6" data-id="element-95">
            👉 SÌ! VOGLIO IL SISTEMA COMPLETO ORA
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 text-brand-gold font-bold text-sm sm:text-base" data-id="element-96">
            <span data-id="element-97">⚡ Accesso immediato</span>
            <span data-id="element-98">·</span>
            <span data-id="element-99">💳 Solo €19,90 — pagamento unico</span>
            <span data-id="element-100">·</span>
            <span data-id="element-101">🛡️ Garanzia 30 giorni soddisfatti</span>
          </div>
        </motion.div>
      </div>
    </section>;
}